import { useSelector } from "react-redux";
import DistrictsList from "../districts/DistrictsList";
import RegionsList from "../regions/RegionList/RegionsList";
import RegionLegend from "../regions/RegionLegend/RegionLegend";
import "./RegionsInfo.css";
import { highlightDistrict } from "../Map/Map";
const RegionsInfo = () => {
    const selectedDistrict = useSelector(
        (state) => state.points.selectedDistrict
    );
    const selectedRegion = useSelector((state) => state.points.selectedRegion);

    // console.log('RegionsInfo - render:', {
    //     selectedDistrict,
    //     selectedRegion
    // });

    if (selectedRegion) {
        return <RegionLegend />;
    }

    if (selectedDistrict) {
        return <RegionsList districtId={selectedDistrict} />;
    }

    return <DistrictsList highlightDistrict={highlightDistrict} />;
};

export default RegionsInfo;
